const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
   <style>
    .container-pagination {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 22px;
    }
    .container-pagination .btn-pagination {
        display: flex;
        background: #3570D2;
        border-radius: 5px;
        padding: 12px 24px;
        font-weight: 600;
        font-size: 16px;
        line-height: 135%;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
        cursor: pointer;
    }
    .ml-12 {
        margin-left: 12px;
    }
   </style>
 </template>`;

styleElement.register("ecourse-list-style");
